import { Badge } from '@material-ui/core';
import { formatDateTimeReadable } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const creationDateAndMerchantNameMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.6,
    field: 'created_at',
    headerName: <Text tId={'CREATION_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData) => {
      return (
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {rowData.row.hasNotifications && (
              <Badge color="primary" badgeContent="" variant="dot">
                <i className="material-icons-outlined mr-2" style={{ fontSize: 18 }}>
                  notifications
                </i>
              </Badge>
            )}
            {formatDateTimeReadable(rowData.row.createdAt)}
          </div>
          <span color={palette.text.secondary}>{rowData.row.registrationFields.businessName}</span>
        </div>
      );
    },
  };
};
